import { render, staticRenderFns } from "./DeletedUser.vue?vue&type=template&id=b7a4a544&"
import script from "./DeletedUser.vue?vue&type=script&lang=js&"
export * from "./DeletedUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports